import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { EMAIL_CLICK_PARAM, EMAIL_CLICK_REF, emailClickService } from '../services/emailClickService';
import { tokenService } from '../services/tokenService';
import { browserSignals, onFirstUse } from '../utils/inviteFirstUse';

const report = (ref: string, input: string) => {
  const signals = browserSignals({ input, after_ms: Math.round(window.performance.now()) });

  void emailClickService.reportUse(ref, signals).catch(() => undefined);
};

/** Signed in: report at once. Otherwise at the first real use of the page. */
const reportVisit = (ref: string) => {
  if (!EMAIL_CLICK_REF.test(ref)) return;
  if (tokenService.hasToken()) report(ref, 'signed_in');
  else onFirstUse(`email:${ref}`, (input) => report(ref, input));
};

/**
 * A notification or campaign email's link that lands on our site carries ``email_click``. Signed in, the visit is
 * reported at once (whose browser it is); otherwise at the first real tap, click, key or scroll. Link scanners do
 * neither, so this is what tells a person's click from a bot's. The parameter is then taken off the address.
 */
export function EmailClickLanding() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get(EMAIL_CLICK_PARAM);

    if (ref === null) return;
    params.delete(EMAIL_CLICK_PARAM);
    const search = params.toString();

    navigate({ pathname: location.pathname, search: search ? `?${search}` : '', hash: location.hash }, { replace: true });
    reportVisit(ref);
  }, [location.search, location.pathname, location.hash, navigate]);

  return null;
}
